export const SDButtonGroupOverrides = (direction, error) => {
  return {
    Root: {
      style: ({ $theme }) => {
        return {
          flexDirection: direction ?? 'initial',
          backgroundColor: $theme.colors.bgMuted,
          width: 'auto',
          marginLeft: '0.01rem',
          border: error ? `solid 2px ${$theme.colors.errorInput}` : `solid 1px ${$theme.colors.borderGroupIdle}`,
          borderTopRightRadius: $theme.borders.radius200,
          borderBottomRightRadius: $theme.borders.radius200,
          borderBottomLeftRadius: $theme.borders.radius200,
          borderTopLeftRadius: $theme.borders.radius200,
        }
      },
    },
  }
}
export const SDButtonGroupButtonOverrides = () => {
  return {
    BaseButton: {
      style: ({ $theme, $disabled, $isSelected }) => {
        const bgColour = $isSelected ? $theme.colors.white : $theme.colors.bgMuted
        const textColor = $disabled ? $theme.colors.textBtnDisabled : $isSelected ? $theme.colors.primary400 : 'inherit'
        const border = $isSelected ? `1px solid ${$theme.colors.primaryAlt}` : '1px solid transparent'
        const hoverOutline = $disabled ? 'none' : `0.125rem solid ${$theme.colors.primaryAlt}`

        return {
          flex: '1 1 auto',
          color: textColor,
          backgroundColor: bgColour,
          border,
          borderRadius: '.375rem',
          ':hover': {
            outline: hoverOutline,
            outlineOffset: '-.125rem',
          },
          ':focus': {
            outline: hoverOutline,
            outlineOffset: '-.125rem',
          },
          ':disabled': {
            backgroundColor: bgColour,
          },
          ':disabled :hover': {
            backgroundColor: bgColour,
          },
          ':disabled :focus': {
            backgroundColor: bgColour,
          },
          ':not(:last-child)': {
            marginRight: '.1875rem',
          },
        }
      },
    },
  }
}
